
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { API_DOMAIN } from './globals'; // Import the global domain name

function Dashboard()
{
    const [InPlayGames, setInPlayGames] = useState(null);  // Store the API response
    const [TNCDisp, setTNCDisp] = useState("");  // Store the API response
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state
    const [userName, setUserName] = useState('');

  useEffect(() => {
    // Define your parameters
    const param1 = sessionStorage.getItem("UserType");
    const param2 = sessionStorage.getItem("UserName");

    setUserName(param2 || '');

    //const TNCDisp= sessionStorage.getItem("TNCDisp");

    setTNCDisp(sessionStorage.getItem("TNCDisp"));

    // Create an object to pass parameters to the GET request
    const params = {
      ut: param1,
      un: param2,
    };

    const queryString = new URLSearchParams(params).toString();
    const url = `${API_DOMAIN}/api/Client/getInPlayGames.php?${queryString}`;

    //console.log(url);

    fetch(url, {
        method: 'GET',
        credentials: 'include', // Equivalent to withCredentials:true
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status=="Error") {
            //console.log(data.Message);
            sessionStorage.setItem("LogoutMsg",data.Message)
            window.location = '/';
            //setInPlayGames([]);
        } else {
            setInPlayGames(data.data); // Save the response data in state
        }        
        setLoading(false); // Set loading to false
    })
    .catch(err => {
        setError(err); // Save any error to the state
        setLoading(false); // Set loading to false
    });

    sessionStorage.setItem("TNCDisp","No");

  }, []);  // Empty dependency array ensures this runs only once when the component mounts

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="match-content">
                <div id="UpCommingData" style={{marginBottom: '90px', background:'linear-gradient(#1f1f22,#fbb81e)'}}>
                    
                    <div className="live-games-heading-block" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <span className="live-games-heading-txt" style={{color : 'white'}}>Casino</span>
                    </div>
                    <div className="match-tabs" >
                        <div className="tab-content">
                            <div className="tab-pane in active">
                                <div className="tabel-scroll" style={{background: '#FFF',marginTop:'5px'}}>
                                    <div className="padding-lr-15 row">  
                                        {/* <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <div className="blink">S
                                                <span className="blink-txt">New Launch</span>
                                            </div>
                                            <Link to="BBB">
                                                <img src="assets/images/ballbyball.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">Ball By Ball</div>
                                            </Link>
                                        </div>                                       */}
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="TPT20">
                                                <img src="assets/images/-1.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">Teen Patti T20</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="TPOdi">
                                                <img src="assets/images/teen.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">Teen Patti Odi</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="DTT20">
                                                <img src="assets/images/-1011.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">Dragon Tiger T20</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="L7A">
                                                <img src="assets/images/-145.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">Lucky 7 A</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="AB2">
                                                <img src="assets/images/-1021.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">Andar Bahar 2</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="AAA">
                                                <img src="assets/images/-1016.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">AAA</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="AAA_v2">
                                                <img src="assets/images/aaa.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">AAA Ver. 2</div>
                                            </Link>
                                        </div>
                                        {/* <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="WM">
                                                <img src="assets/images/-153.webp" className="casino-img-home" alt=""/>
                                                <div className="game-text">Worli Matka</div>
                                            </Link>
                                        </div> */}
                                        {/* <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                                                <img src="assets/images/superover2.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">Super Over 2</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                                                <img src="assets/images/btable.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">Bollywood Casino</div>
                                            </Link>
                                        </div>
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                                                <img src="assets/images/card32.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">32 Cards A</div>
                                            </Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="live-games-heading-block" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <span className="live-games-heading-txt" style={{color : 'white'}}>Virtual Games & Matka</span>
                    </div>
                    <div className="match-tabs" >
                        <div className="tab-content">
                            <div className="tab-pane in active">
                                <div className="tabel-scroll" style={{background: '#FFF',marginTop:'5px'}}>
                                    <div className="padding-lr-15 row">

                                        {/* <?php if(strtoupper($LotteryBet)=="UNLOCK" || strtoupper($LotteryBet)=="YES" || strtoupper($LotteryBet)=="ON") { ?> */}
                                        <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <Link to="Matka">
                                                <img src="assets/images/matka.png" className="casino-img-home" alt=""/>
                                                <div className="game-text">Matka</div>
                                            </Link>
                                        </div>
                                        {/* <?php } ?> */}

                                        {/* <div className="text-center padding-lr-0 col-4 col-md-2">
                                            <a href="#" onClick={() => alert('Comming Soon')}>
                                                <img src="assets/images/ludo.png" className="casino-img-home" alt=""/>
                                                <div className="game-text">Ludo</div>
                                            </a>
                                        </div> */}

                                        {/* <div className="text-center padding-lr-0 col-4 col-md-2">
                                            
                                            <Link to="/Aviator">
                                                <img src="assets/images/aviator.jpg" className="casino-img-home" alt=""/>
                                                <div className="game-text">Aviator</div>
                                            </Link>
                                        </div> */}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    

                    <div className="live-games-heading-block" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <span className="live-games-heading-txt" style={{color : 'white'}}>Cricket</span>
                    </div>
                    <div className="match-tabs" >
                        <div className="tab-content">
                            <div className="tab-pane in active">
                                <div className="tabel-scroll">
                                    <table className="market-listing-table open_bets-table">
                                        <thead>
                                            <tr>
                                                <th className="title">
                                                    <i style={{margin: '0px 5px', color: 'green'}} className="fa far fa-play-circle"></i>Cricket
                                                </th>
                                                <th className="col-first-player  _align-center" colSpan="2">1</th>
                                                <th className="player-draw  _align-center ng-scope" colSpan="2" style={{background:'linear-gradient(#1f1f22,#fbb81e)'}}>X</th>
                                                <th className="col-second-player  _align-center" colSpan="2">2</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table className="market-listing-table" style={{width:'98%',paddingLeft: '10px'}}>
                                        <tbody >
                                            {InPlayGames && InPlayGames.length > 0 ? (
                                            InPlayGames.map((row, index) => (
                                            <tr key={index} title="{row.MatchName}" style={{padding: '5px',color: 'black'}}>
                                                <td style={{ padding: '6px 0', color:'black' }}>
                                                    <Link
                                                        to={`/Dashboard/MSPosition/${row.MatchCode}/${row.MatchID === "" ? '0' : row.MatchID}/${row.MatchType}`}
                                                        className="event-name"
                                                        style={{
                                                        width: '100%',
                                                        textDecoration: 'none',
                                                        color:'black'
                                                        }}
                                                    >
                                                        {/* MATCH NAME */}
                                                        <div
                                                        style={{
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            paddingLeft: '5px'
                                                        }}
                                                        >
                                                        {row.MatchName}
                                                        </div>
                                                        
                                                        {/* DATE + ICON */}
                                                        <div style={{ marginTop: '4px',
                                                            paddingLeft: '5px' }}>
                                                        <small>
                                                            <time>
                                                            {new Date(row.MatchTime).toLocaleDateString("en-IN", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                second: "2-digit",
                                                                hour12: true,
                                                                timeZone: "Asia/Kolkata"
                                                            })}
                                                            </time>
                                                            <span style={{ marginLeft: '6px' }}>
                                                            <img width="20" src="assets/images/live-tv.png" alt="Live" />
                                                            </span>
                                                        </small>
                                                        </div>
                                                    </Link>
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={`/Dashboard/MSPosition/${row.MatchCode}/${row.MatchID === "" ? '0' : row.MatchID}/${row.MatchType}`}
                                                            className="event-name"
                                                            style={{
                                                            width: '100%',
                                                            textDecoration: 'none',
                                                            color:'black'
                                                            }}
                                                        >
                                                            <span
                                                            className="in_play"
                                                            style={{
                                                                backgroundColor: row.Status === 'Inplay' ? 'green' : 'blue',
                                                                color: '#fff',
                                                                borderRadius: '4px',
                                                                fontSize: '12px'
                                                            }}
                                                            >
                                                                {row.Status}
                                                            </span>
                                                        </Link>
                                                        
                                                    </td>
                                                {/* <td className="back betting-blue first-el" style={{marginBottom: '5px'}}>
                                                    <strong className="odds ng-binding">-</strong>
                                                </td>
                                                <td className="lay betting-pink">
                                                    <strong className="odds ng-binding">-</strong>
                                                </td>
                                                <td className="back betting-blue">
                                                    <strong className="odds ng-binding">-</strong>
                                                </td>
                                                <td className="lay betting-pink">
                                                    <strong className="odds ng-binding">-</strong>
                                                </td>
                                                <td className="back betting-blue">
                                                    <strong className="odds ng-binding">-</strong>
                                                </td>
                                                <td className="lay betting-pink last-el">
                                                    <strong className="odds ng-binding">-</strong>
                                                </td> */}
                                            </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center', padding: '10px' }}>
                                                No data available
                                                </td>
                                            </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="betSidenav" className="betsidenav">
                <section className="right-bet-content">
                    <div className="right-bet-inner">
                        <div className="mod-header tab_bets betsheading" style={{display: 'block',color:'black'}}>
                            <ul className="nav nav-pills mb-1" id="pills-tab" role="tablist">
                                <li className="nav-item betdata active">
                                    <a className="allbet" style={{color:'black'}}>
                                        <span className="bet-label">All Bet </span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item betdata">
                                    <a className="unmatchbet" style={{color:'black'}}>
                                        <span className="bet-label">Match Bet</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item betdata">
                                    <a className="unmatchbet" style={{color:'black'}}>
                                        <span className="bet-label">Fancy Bet</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item betdata">
                                    <a className="unmatchbet">
                                        <span className="bet-label blinking">Casino Bet</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item betdata">
                                    <a className="unmatchbet">
                                        <span className="bet-label blinking">Matka Bet</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item full-screen"></li>
                            </ul>
                        </div>
                        <div id="MatchUnMatchBetaData">
                            <div id="accountView" role="main">
                                <span id="msg_error"></span>
                                <span id="errmsg"></span>
                                <div className="balance-panel-body">
                                    <div className="table-responsive sports-tabel">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr className="heading_user_table"  style={{background:'#000'}}>
                                                    <td>Team</td>
                                                    <td>Mode</td>
                                                    <td>Run</td>
                                                    <td>Rate</td>
                                                    <td>Amount</td>
                                                </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {TNCDisp == "Yes" && (
                <div style={{ position: "relative", zIndex: 1050 }} id="TnC">
                    <div className="modal fade show" style={{ display: "block", overflow: "scroll" }} role="dialog" tabIndex="-1">
                        <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title">Rules / नियम</h5>
                            {/* <button type="button" className="close" aria-label="Close" onClick={() => { document.getElementById('TnC').style.display = 'none'; }}>
                                <span aria-hidden="true">×</span>
                            </button> */}
                            </div>
                            <div className="modal-body">
                            <p>1. कृपया Run 99 के नियमों को समझने के लिए यहां कुछ मिनट दें, और अपने अनुसार समझ लें |</p>
                            <p>2. सभी डीलर्स से निवेदन है कि क्लाइंट्स को Run 99 के रूल्स समझाने के बाद ही सौदे करवायें।</p>
                            <p>3. अगर आप इस एग्रीमेंट को ऐक्सेप्ट नहीं करते हे तो कोई सौदा नहीं कीजिये।</p>
                            <p>4. इंटरनेट कनेक्शन प्रॉब्लम की जिम्मेवारी आपकी रहेगी</p>
                            <p>5. यहाँ सभी सौदे लेजर से मान्य किये जायेंगे</p>
                            <p>6. मैच के टाई और रद्द होने पे सारी कंप्लीटेड फैंसी का लेन देन किया जायेगा </p>
                            <p>7. साइट मैं किसी भी टेक्निकल Error आने की सूरत मैं मैच और सेशन मैं लगी सभी बेट्स का लेन देन होगा </p>
                            <p>8. अगर किसी भी मैच मैं भाव और फैंसी मैं गलत रेट चलने की सूरत मैं कंपनी अपने राइट्स से बेट्स डिलीट कर सकता है ऐसी सूरत मैं कोई भी वाद विवाद मान्य नहीं होगा </p>
                            <p>9. किसी मैच मैं रिजल्ट गलत हो जाने की सूरत मैं मैच खत्म हो जाने के बाद भी उसे सही किया जा सकता है इस सिचुएशन मैं कोई भी वाद विवाद। मान्य नहीं होगा </p>
                            <p>10. अगर एक्सचेंज मैं कोई भी चीट बेट्स पाई जाती है तो बिना किसी वाद विवाद के उसे कंपनी की तरफ से डिलीट कर दिया जायेगा </p>
                            <p>11. एक्सचेंज का स्कोरबोर्ड थर्ड पार्टी से लिया गया है उसे देख कर सौदे करने पर एक्सचेंज जिम्मेदार नहीं होगा </p>
                            <p>12. कंपनी द्वारा दिया गया पासवर्ड आपको खुद चेंज करना है ये आपकी अपनी जिम्मेदारी है इसके लिए कंपनी से कोई भी वाद विवाद मान्य नहीं होगा </p>
                            <p>13. अगर चलते मैच मैं किसी भी टेक्निकल इश्यू की वजह से एक्सचेंज डाउन होता है तो उस मैच और सेशन पर लगी हुई सभी बेट्स का लेन देन होगा इस सिचुएशन मैं कोई वाद विवाद मान्य नहीं होगा</p>
                            <p>14. कैसिनो के किसी भी गेम या राउंड का रिजल्ट नहीं बनने की स्थिती में उस सौदे का कोई लेन देन नहीं होगा। वो बेट २ घंटे के अंदर कैंसिल कर दी जाएगी और उसका एक्सपोज़र वापिस कर दिया जायेगा </p>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => { document.getElementById('TnC').style.display = 'none'; }}>Agree</button>
                            {/* <button type="button" className="btn btn-secondary" onClick={() => { document.getElementById('TnC').style.display = 'none'; }}>Cancel</button> */}
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>
            )}
        </>
    )
}
export default Dashboard